import moment from 'moment';
import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
// client-notes 2026-08-16 K5: Leaflet click-to-pick map for outlet coordinates
// (same component the Schools/Students dialogs use; it already handles the
// hidden-modal zero-size problem internally).
import MapPicker from '../../Shared/MapPicker.vue';

// client-notes 2026-08-16 K5: working-day bits — Sun=1 … Sat=64, the
// School.WorkingDaysBitmask convention the backend shares.
const WORKING_DAYS = [
    { bit: 1, label: 'الأحد' },
    { bit: 2, label: 'الإثنين' },
    { bit: 4, label: 'الثلاثاء' },
    { bit: 8, label: 'الأربعاء' },
    { bit: 16, label: 'الخميس' },
    { bit: 32, label: 'الجمعة' },
    { bit: 64, label: 'السبت' },
];
const ALL_DAYS_MASK = 127;

export default {
    name: 'Courses',
    mixins: [HelperMixin],
    components: {
        PaginationHelper,
        MapPicker
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;

        this.GetInfo();
        this.GetAllPaymentMethods();
        this.GetAllFinancialsWithdrawing();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('DD/MM/YYYY');
        },

        momentTime: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('DD/MM/YYYY || HH:MM');
        }
    },
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: '  الموزعين ',
            ScreenTitleSingle: '  موزع   ',
            ScreenTitleSingleAl: ' الموزع  ',

            Info: [],
            Statistics: [],

            InfoFinancialsTracker: [],

            AddDialog: false,

            SelectedItem:'',

            ruleForm: {
                Id: '',
                Name: '',
                LoginName: '',
                Email: '',
                Phone: '',
                Image: '',
                ImageName: '',
            },
            rules: {
                Name: this.$helper.Required(),
                Phone: this.$helper.Phone(),
                Email: this.$helper.EmailOnly(),
                LoginName: [
                    { required: true, message: 'الرجاء إدخال اسم الدخول', trigger: 'blur' },
                    { required: true, pattern: /^[A-Za-z]{0,40}$/, message: 'الرجاء إدخال اسم الدخول بطريقه صحيحه', trigger: 'blur' }
                ],
            },

            FinancialsruleForm: {
                Id: '',
                PaymentMethodsId: '',
                WithdrawingId: '',
                OperationOn: '',
                Value: '',
                Descriptions: '',
            },
            Financialsrules: {
                PaymentMethodsId: this.$helper.Required(),
                WithdrawingId: this.$helper.Required(),
                OperationOn: this.$helper.Required(),
                Value: this.$helper.Required(),
                Descriptions: this.$helper.Required(),
            },

            // client-notes 2026-08-16 K5: «المواقع» — the distributor's sale points
            // (UsersLocations rows) that the mobile wallet lists as أماكن بيع الكروت.
            WorkingDays: WORKING_DAYS,
            InfoLocations: [],
            locationMapValue: { lat: null, lng: null },
            locationForm: {
                Id: null,
                UserId: null,
                Name: '',
                Phone: '',
                Latitude: '',
                Longitude: '',
                OpenTime: '',
                CloseTime: '',
                WorkingDaysBits: [],
                IsPrimary: false,
            },
        };
    },



    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetDistributors(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(0);
                    this.$blockUI.Start();
                    this.$http.AddDistributors(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.LoginName = item.loginName;
            this.ruleForm.Email = item.email;
            
        },

        submitEditForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(this.ruleForm.Id);
                    this.$blockUI.Start();
                    this.$http.EditDistributors(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تغير حالة العرض  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusDistributors(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        ResetPassword(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تهيئة كلمة المرور   ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ResetPasswordDistributors(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteDistributors(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        //Upload File
        SelectImage(file) {

            // Check if file is defined
            if (!file) {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'يرجى اختيار ملف');
                return;
            }

            let str = file.type; // Access type property safely
            str = str.substring(0, 5);

            // Check if the file type is an image
            if (str !== "image") {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'الرجاء التأكد من نوع الملف');
                return;
            }

            var $this = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $this.ruleForm.ImageName = file.name;
                $this.ruleForm.Image = reader.result;
            };
        },



        //Financials
        OpenFinancials(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.LoginName = item.loginName;
            this.ruleForm.Email = item.email;
            this.ruleForm.UserType = item.userType;
        },

        submitFinancialsruleForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.FinancialsruleForm.Id = this.SelectedItem.id;
                    this.FinancialsruleForm.Value = Number(this.FinancialsruleForm.Value);
                    this.$blockUI.Start();
                    this.$http.PayUsersFinancials(this.FinancialsruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.GetFinancialsTracker();
                            this.ClearForm(this.FinancialsruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        OpenFinancialsTracker(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.LoginName = item.loginName;
            this.ruleForm.Email = item.email;
            this.ruleForm.UserType = item.userType;
            this.GetFinancialsTracker();

        },

        GetFinancialsTracker() {
            this.$blockUI.Start();
            this.$http.GetUsersFinancials(this.SelectedItem.id)
                .then(response => {
                    this.$blockUI.Stop();
                    this.InfoFinancialsTracker = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        DeleteFinancials(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteUsersFinancials(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                            this.GetFinancialsTracker();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        // ------------------------------------------------------------------
        // client-notes 2026-08-16 K5: distributor outlets («المواقع»).
        // Reuses the admin User-Locations CRUD (api/admin/Users/{id}/Locations)
        // — a distributor IS a User, so its shops are ordinary UsersLocations
        // rows carrying the extra Phone / OpenTime / CloseTime / WorkingDays.
        // ------------------------------------------------------------------
        OpenLocations(item) {
            this.SelectedItem = item;
            this.InfoLocations = [];
            this.resetLocationForm();
            this.GetLocations();
        },

        GetLocations() {
            if (!this.SelectedItem || !this.SelectedItem.id) return;
            this.$blockUI.Start();
            this.$http.GetUserLocations(this.SelectedItem.id, 1, 100)
                .then(response => {
                    this.$blockUI.Stop();
                    this.InfoLocations = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.InfoLocations = [];
                });
        },

        resetLocationForm() {
            this.locationForm = {
                Id: null,
                UserId: this.SelectedItem ? this.SelectedItem.id : null,
                Name: '',
                Phone: '',
                Latitude: '',
                Longitude: '',
                OpenTime: '',
                CloseTime: '',
                WorkingDaysBits: WORKING_DAYS.map(d => d.bit),
                IsPrimary: false,
            };
            this.locationMapValue = { lat: null, lng: null };
        },

        editLocation(loc) {
            this.locationForm = {
                Id: loc.id,
                UserId: loc.userId,
                Name: loc.name || '',
                Phone: loc.phone || '',
                Latitude: loc.latitude || '',
                Longitude: loc.longitude || '',
                OpenTime: this.fmtTime(loc.openTime, ''),
                CloseTime: this.fmtTime(loc.closeTime, ''),
                WorkingDaysBits: this.bitsFromMask(loc.workingDaysBitmask),
                IsPrimary: !!loc.isPrimary,
            };
            const lat = Number(loc.latitude), lng = Number(loc.longitude);
            this.locationMapValue = (lat && lng) ? { lat, lng } : { lat: null, lng: null };
        },

        onLocationMapPicked(v) {
            this.locationMapValue = v;
            this.locationForm.Latitude = String(v.lat);
            this.locationForm.Longitude = String(v.lng);
        },

        submitLocationForm() {
            const f = this.locationForm;
            if (!f.Name || !f.Name.trim()) {
                this.$helper.ShowMessage('error', 'خطأ', 'يرجى إدخال اسم نقطة البيع');
                return;
            }
            const lat = Number(f.Latitude), lng = Number(f.Longitude);
            // Same Libya box the mobile app enforces (map_defaults.isInLibya) — a
            // pin at (0,0) or in the sea would render on the riders' map.
            if (!(lat >= 19 && lat <= 34 && lng >= 9 && lng <= 26)) {
                this.$helper.ShowMessage('error', 'خطأ', 'حدّد موقع نقطة البيع على الخريطة (داخل ليبيا)');
                return;
            }
            if ((f.OpenTime && !f.CloseTime) || (!f.OpenTime && f.CloseTime)) {
                this.$helper.ShowMessage('error', 'خطأ', 'أدخل وقت الفتح ووقت الإغلاق معاً أو اتركهما فارغين');
                return;
            }
            if (!f.WorkingDaysBits.length) {
                this.$helper.ShowMessage('error', 'خطأ', 'اختر يوم عمل واحداً على الأقل');
                return;
            }
            const body = {
                Id: f.Id,
                UserId: this.SelectedItem.id,
                Name: f.Name.trim(),
                Phone: (f.Phone || '').trim(),
                Latitude: String(lat),
                Longitude: String(lng),
                OpenTime: f.OpenTime || '',
                CloseTime: f.CloseTime || '',
                WorkingDaysBitmask: this.maskFromBits(f.WorkingDaysBits),
                IsPrimary: !!f.IsPrimary,
            };
            this.$blockUI.Start();
            const call = f.Id ? this.$http.EditUserLocation(body) : this.$http.AddUserLocation(body);
            call.then(response => {
                this.$blockUI.Stop();
                this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                this.resetLocationForm();
                this.GetLocations();
            }).catch(err => {
                this.$blockUI.Stop();
                if (err.response && err.response.data) {
                    this.$helper.ShowMessage('error', 'خطأ بعملية الحفظ', err.response.data);
                } else {
                    this.$helper.ShowMessage('error', 'خطأ بعملية الحفظ', 'حدت خطاء غير متوقع');
                }
            });
        },

        deleteLocation(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من حذف نقطة البيع ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteUserLocation(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            if (this.locationForm.Id === Id) this.resetLocationForm();
                            this.GetLocations();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        // "08:00:00" (API) -> "08:00" (input type=time / display).
        fmtTime(t, empty = '—') {
            if (!t) return empty;
            return String(t).substring(0, 5);
        },

        bitsFromMask(mask) {
            const m = (mask === null || mask === undefined) ? ALL_DAYS_MASK : Number(mask);
            return WORKING_DAYS.filter(d => (m & d.bit) !== 0).map(d => d.bit);
        },

        maskFromBits(bits) {
            return (bits || []).reduce((acc, b) => acc | b, 0);
        },

        workingDaysLabel(mask) {
            const bits = this.bitsFromMask(mask);
            if (bits.length === WORKING_DAYS.length) return 'كل الأيام';
            if (!bits.length) return '—';
            return WORKING_DAYS.filter(d => bits.includes(d.bit)).map(d => d.label).join('، ');
        },

        hoursLabel(loc) {
            if (!loc.openTime || !loc.closeTime) return 'غير محدد';
            return `${this.fmtTime(loc.openTime)} – ${this.fmtTime(loc.closeTime)}`;
        },

        mapsLink(loc) {
            return `https://www.google.com/maps?q=${loc.latitude},${loc.longitude}`;
        },

    }
}
